// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"43e34e03","862":"5c208d7c","873":"116a29fc"}[chunkId] + ".chunk.css";
};